import React from "react";
import ReactDOM from "react-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import App from "./App";

ReactDOM.render(
  <Auth0Provider
    domain="dev-5dlfqpsvtzau1bzx.us.auth0.com" // Your Auth0 domain
    clientId="G1VJtFgN3ECBaOQ8gUEas0fSvQFP8Qai" // Your Auth0 client ID
    authorizationParams={{
      redirect_uri: window.location.origin + "/callback", // Default to current domain
    }}
  >
    <App />
  </Auth0Provider>,
  document.getElementById("root")
);